<div class="tag-container" *ngIf="tagList && tagList.length > 0" (click)="onClick($event)">
    <ng-container *ngFor="let tag of tagList">
      <p-chip [rounded]="true" class="flex align-items-center filter-tag">
        <span class="p-chip-text mt-1 mb-1"><bdi>{{ tag.label | translateLang |async }}</bdi> </span>
        <i   
          class="pi pi-times mr-2 mt-1 cursor-pointer chip-icon"
          (click)="onRemove($event, tag)"
          (keydown.enter)="onRemove($event, tag)"
          role="button"
          tabindex="0"
          [attr.aria-label]="('iaa.general.removeTag' | translate)+ ' ' + (tag.label | translateLang | async) "          ></i>
      </p-chip>
    </ng-container>
  </div>